import { IJSONEditingService, IJSONValue, JsonEditingWriteDocument, IJsonEditingWriteMutation, IJsonEditingWriteMutationVariables } from '@workbench-stack/core';
import { URI } from '@vscode-alt/monaco-editor/esm/vs/base/common/uri';
import { injectable, inject } from 'inversify';
import { ApolloClient } from 'apollo-client';
import { ClientTypes as CommonTypes } from '@common-stack/client-core';


@injectable()
export class JSONEditingService implements IJSONEditingService {

    constructor(
        @inject(CommonTypes.ApolloClient)
        private client: ApolloClient<any>,
    ) {
    }
    public async write(resource: URI, value: IJSONValue, save: boolean) {
        await this.client.mutate<IJsonEditingWriteMutation, IJsonEditingWriteMutationVariables>({
            mutation: JsonEditingWriteDocument,
            variables: {
                resource,
                value,
                save,
            },
        });
    }
}
